import React, { Component } from 'react';
import './App.css';
import 'bootstrap/dist/css/bootstrap.css';
import './shards.css';
import { Redirect } from 'react-router';
import {
  BrowserRouter as Router,
  Route,
  Link
} from 'react-router-dom';
import './Results.css';

import fire from './fire';

import { firstUserKey } from './Main';

import {card} from './card';

import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';


import {
  ShareButtons,
  ShareCounts,
  generateShareIcon,
} from 'react-share';

const {
  FacebookShareButton,
  TelegramShareButton,
  WhatsappShareButton,
  EmailShareButton,
} = ShareButtons;

const FacebookIcon = generateShareIcon('facebook');
const TelegramIcon = generateShareIcon('telegram');
const WhatsappIcon = generateShareIcon('whatsapp');
const EmailIcon = generateShareIcon('email');



export default class DoneMain extends React.Component {

	constructor(props) {
    	super(props);
    	
    	
  	}


  	


  	

	
	


	render() {

		const shareUrl = window.location.href;
    	const title = 'Check out our Pairful results';
    	const firstUserKey = this.props.location.pathname.slice(10);
		
		

	

		
			return (
				<div>
				<div className="bg-light">
					<div>
		 					<div className="row justify-content-center text-center bg-img1 align-items-center" style={{marginTop: 0}}>
				 				<div className="col-sm-12 col-md-8 col-lg-6" style={{marginTop: 0}}>
				 					
				    				<h3 className="display-4 text-light">All done!</h3>
				    				<p className="lead text-light">Now share with your partner to fill out...</p>
				    				
				    				
				    			
				  				</div>
				  			</div>
				  			
				  	</div>
					<main role="main" className="container" style={{marginTop: 70}} id="share-results">
					<div className="row justify-content-center align-items-center" style={{marginBottom: 40}}>
						<div className="col-sm-12 col-md-5"> 
							<p className="lead text-muted text-left">Share <Link to={'/stepTwo/' + firstUserKey}>this link</Link> with your partner or use a share button:</p>
						</div>
						<div className="col-sm-12 col-md-4"> 
							<div className="row justify-content-center align-items-center">
						<div className="col mx-auto">
							<div className="social-buttons mx-auto">
								<FacebookShareButton
					            url={shareUrl}
					            quote={title}
					            >
					            <FacebookIcon
					              size={32}
					              round />
					          </FacebookShareButton>
				          	</div>
		          
						</div>
						<div className="col">
							<div className="social-buttons mx-auto">
								<WhatsappShareButton
					            url={shareUrl}
					            title={title}
					            >
					            <WhatsappIcon
					              size={32}
					              round />
					          </WhatsappShareButton>
				          	</div>
		          
						</div>
						<div className="col">
							<div className="social-buttons mx-auto">
								<TelegramShareButton
					            url={shareUrl}
					            title={title}
					            >
					            <TelegramIcon
					              size={32}
					              round />
					          </TelegramShareButton>
				          	</div>
		          
						</div>
						<div className="col">
							<div className="social-buttons mx-auto">
								<EmailShareButton
					            url={shareUrl}
					            subject={title}
					            body={title}
					            >
					            <EmailIcon
					              size={32}
					              round />
					          </EmailShareButton>
				          	</div>
		          		</div>
		          		</div>
						</div>
					</div>
					
						

					
					
			     
			      </main>
			      <footer className="text-muted bg-dark" style={{marginTop:50}}>

				      <div  style={{paddingTop:80, paddingBottom:40, paddingRight:20, paddingLeft:20}}>
				        <p className="float-right small">
				          <a href="http://www.louisnicholls.com" style={{color:'#c1c1c1'}}>&copy; Louis Nicholls 2017</a>
				          
				        </p>
				        <p className="float-left small">
				          <a href="https://unsplash.com/photos/AsahNlC0VhQ" style={{color:'#c1c1c1'}}>Photo by Everton Vila at Unsplash</a>
				          
				        </p>
				        
				      </div>
				    </footer>
				    </div>
				    <div className="fixed-bottom">
				    <div className="row justify-content-end">
				    <div className="col-sm-12 col-md-4">
				    
				    </div>
				    </div>
			      	</div>
			      </div>

			);
	






}
}














// WEBPACK FOOTER //
// ./src/DoneMain.js